import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7530c2fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "terms-container" }
const _hoisted_2 = {
  key: 0,
  class: "content"
}
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["NavigationBar"], {
      title: $setup.selectedTerms?.title ?? '',
      shouldShowUnderline: true,
      showBackButton: false
    }, null, 8 /* PROPS */, ["title"]),
    ($setup.selectedTerms?.url)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          _createElementVNode("iframe", {
            class: "terms",
            src: $setup.selectedTerms.url
          }, null, 8 /* PROPS */, _hoisted_3)
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}